// Central site config.
// Native booking page (replaces the old external calendar). Used by the hero
// CTA, the contact "book directly" card, and the checklist email CTA.
export const BOOKING_PATH = "/book";

// Detailed qualification flow (rich lead form). The primary "Book a Secure
// System Audit" CTAs across the site route here.
export const AUDIT_PATH = "/secure-system-audit";

// Social profiles
export const LINKEDIN_URL = "https://www.linkedin.com/company/reverseai-dk/";

// Uploaded brand assets.
// Hero video ships at two resolutions, each in two codecs. Wide viewports get
// the crisp 1080p pair; narrow viewports and saveData get the lean 720p pair.
// The WebM is the codec fallback for browsers without H.264 support.
export const HERO_VIDEO_1080 = { mp4: "/hero-video-1080.mp4", webm: "/hero-video-1080.webm" };
export const HERO_VIDEO_720 = { mp4: "/hero-video.mp4", webm: "/hero-video.webm" };
export const HERO_POSTER_URL =
  "https://customer-assets.emergentagent.com/job_spreadsheet-rebuild/artifacts/mhp71ccs_AI_konsulent_excel_to_Ai_systems_emergent_under5mb_q94_2048w.jpg";
export const FOUNDER_IMAGE_URL =
  "https://customer-assets.emergentagent.com/job_spreadsheet-rebuild/artifacts/ynoqgr8q_peter_Ai_konsulent_emergent_under5mb_q94_1365w.jpg";

// Cinematic section loops (lazy-loaded, muted/looped ambient layers).
export const VIDEO_MID_SECTION =
  "https://customer-assets.emergentagent.com/job_spreadsheet-rebuild/artifacts/px308i2j_ReverseAi.dk%20mid-sektion.mp4";
export const VIDEO_PROOF_LOOP =
  "/videos/proof-1080.mp4";
export const VIDEO_CTA_SECTION =
  "/videos/cta-1080.mp4";
// Native 1920x1080 at every viewport size. MP4 keeps the original video
// bitstream; VP9 is a same-resolution fallback, never a mobile downgrade.
export const VIDEO_PROOF_SOURCES = [
  { src: VIDEO_PROOF_LOOP, type: "video/mp4" },
  { src: "/videos/proof-1080.webm", type: "video/webm" },
];
export const VIDEO_CTA_SOURCES = [
  { src: VIDEO_CTA_SECTION, type: "video/mp4" },
  { src: "/videos/cta-1080.webm", type: "video/webm" },
];

// ------------------------------------------------------------
// Higgsfield-generated visual assets (optional). Leave a value as "" to keep
// that spot's built-in CSS/SVG visual. Paste an uploaded asset URL to activate
// it — no component changes needed, it swaps in automatically with a brand
// readability overlay / glass frame.
//   problemBg / securityBg / processBg : full-bleed section background art
//   decorPanel : replaces the floating glass panel decoration (Services / Pricing / Maintenance / Process)
//   decorGraph : replaces the decorative node-graph SVG
// ------------------------------------------------------------
// All values intentionally empty: the site uses ONLY native CSS / SVG /
// Framer-Motion effects (animated grids, dependency-graph SVG, formula trails,
// glass panels). Disabled the generated raster assets in the P0 visual-QA pass
// to remove floating image cards / stock-looking blocks. Each component falls
// back to its built-in vector visual when the value is "".
export const ASSETS = {
  problemBg: "",
  securityBg: "",
  processBg: "",
  decorPanel: "",
  decorGraph: "",
};

// Nav items reference translation keys (nav.<key>); hrefs stay constant.
export const NAV_LINKS = [
  { key: "platform", href: "#specialist" },
  { key: "proof", href: "#proof" },
  { key: "pricing", href: "#priser" },
  { key: "maintenance", href: "#vedligeholdelse" },
  { key: "about", href: "#om" },
];
